import { Button, SlideOut, spacing, palette, typography } from '@digitools/honest-ui';
import { EmployerMessageIcon } from '@digitools/honest-ui/icons';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import useTranslate from '../../../../../hooks/useTranslate';
import { MessageContainerText } from './MessageContainerText';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
const StyledButton = styled(Button) `
    color: ${palette.gray700};
    font-weight: ${typography.fontWeight.bold};
    border-radius: var(--radius-md);
    padding: ${spacing.xs} ${spacing.xs};
    gap: ${spacing.xxs};

    &:hover {
        background-color: ${palette.gray200};
        text-decoration: none;
    }
    &:focus-visible {
        text-decoration: none;
    }
    &:active {
        text-decoration: underline;
    }
    svg {
        width: 24px;
        height: 24px;
    }
`;
const StyledMessage = styled('div') `
    color: ${palette.black800};
    font-family: ${typography.fontFamily.sans};
    font-size: ${typography.fontSize.md};
    font-weight: ${typography.fontWeight.normal};
    line-height: normal;
`;
const StyledHeading = styled('span') `
    display: inline-flex;
    align-items: center;
    gap: ${spacing.xs};
    font-family: ${typography.fontFamily.serif};
`;
const MessagesContainer = ({ trackPageEvent, landingPageResource }) => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef(null);
    if (experience !== Experience.EMPLOYEE)
        return null;
    const message = landingPageResource?.employerMessage?.english
        ? landingPageResource.employerMessage
        : MessageContainerText.noMessages;
    const toggleMessages = () => {
        setIsOpen(!isOpen);
        trackPageEvent && trackPageEvent('Employer Messages');
    };
    return (<>
        <StyledButton ref={triggerRef} type='text' label={t(MessageContainerText.messageButtonLabel)} icon={<EmployerMessageIcon />} onClick={toggleMessages}/>
        <SlideOut heading={<StyledHeading>
              <EmployerMessageIcon />
              {t(MessageContainerText.messageButtonLabel)}
            </StyledHeading>} divider headingSize={"h3"} headingLabel={t(MessageContainerText.messageButtonLabel)} closeLabel={t(MessageContainerText.closeLabel)} isOpen={isOpen} onOpenChange={setIsOpen} triggerRef={triggerRef}>
            <StyledMessage dangerouslySetInnerHTML={{ __html: t(message) }}/>
        </SlideOut>
      </>);
};
export default MessagesContainer;
